export const departmentManage = [
  //部门管理相关
  {
    name: 'department',
    path: 'department',
    component: () => import('@/page/main/department'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '部门管理', path: '' },
      ],
    },
  },
]
export const userManage = [
  //用户管理相关
  {
    name: 'userDateil',
    path: 'userDateil',
    component: () => import('@/page/main/user/userDateil'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '个人信息', path: '' },
      ],
    },
  },
  {
    name: 'OPPEIN',
    path: 'user/oppein',
    component: () => import('@/page/main/user/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '用户管理', path: '' },
        { title: '集团用户', path: 'user/oppein' },
      ],
    },
  },
  {
    name: 'AGENT',
    path: 'user/agent',
    component: () => import('@/page/main/user/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '用户管理', path: '' },
        { title: '经销商用户', path: 'user/agent' },
        { title: '外部人员管理', path: 'user/agent' },
      ],
    },
  },
  {
    name: 'EXTERNAL',
    path: 'user/external',
    component: () => import('@/page/main/user/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '用户管理', path: '' },
        { title: '外部人员管理', path: 'user/external' },
      ],
    },
  },
  {
    name: 'OVERSEAS',
    path: 'user/overseas',
    component: () => import('@/page/main/user/overseas'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '用户管理', path: '' },
        { title: '海外账号管理', path: 'user/overseas' },
      ],
    },
  },
  {
    name: 'userChange',
    path: 'userChange',
    component: () => import('@/page/main/user/change'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '配置用户', path: '' },
      ],
    },
  },
]
export const roleManage = [
  //角色管理相关
  {
    name: 'role',
    path: 'role',
    component: () => import('@/page/main/role/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '角色管理', path: '' },
      ],
    },
  },
  {
    name: 'role-manager',
    path: 'role-manager/:roleId/:type',
    component: () => import('@/page/main/role/role-manager'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '角色列表', path: '/main/role' },
        { title: '管理角色' },
      ],
    },
  },
  {
    name: 'roleChildren',
    path: 'role/:id/children',
    component: () => import('@/page/main/role/children'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '角色管理列表', path: '/main/role' },
        { title: '配置角色的可管理角色', path: '' },
      ],
    },
  },
  {
    name: 'roleLevel',
    path: 'role/roleLevel',
    component: () => import('@/page/main/role/levels/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '角色管理', path: '' },
        { title: '角色分层配置', path: '/main/role/roleLevel' },
      ],
    },
  },
]
export const linerManage = [
  //线别管理相关
  {
    path: 'line',
    component: () => import('@/page/main/line'),
    meta: {
      router: [
        { title: '首页', path: '/main/line' },
        { title: '线别管理', path: '' },
      ],
    },
  },
]
export const businessManagement = [
  //大商管理相关
  {
    name: 'bigBusinessManagement',
    path: 'bigBusinessManagement',
    component: () => import('@/page/main/businessManagement/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '大商管理', path: '/main/bigBusinessManagement' },
      ],
    },
  },
  {
    name: 'seeMarkentManaget',
    path: 'businessManagement_seeMarket',
    component: () => import('@/page/main/businessManagement/seeMarket'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '查看商场', path: '/main/businessManagement_seeMarket' },
      ],
    },
  },
  {
    name: 'invitationHistory',
    path: 'businessManagement_invitationHistory',
    component: () => import('@/page/main/businessManagement/invitationHistory'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '邀请历史', path: '/main/businessManagement_invitationHistory' },
      ],
    },
  },
]
export const dictionaryManage = [
  //字典管理相关
  {
    name: 'dict',
    path: 'dict',
    component: () => import('@/page/main/dict'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '字典管理', path: '' },
      ],
    },
  },
]
export const permissionManage = [
  //权限管理相关
  {
    name: 'access',
    path: 'access',
    component: () => import('@/page/main/access'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '权限管理', path: '' },
      ],
    },
  },
]
export const baseConfigManage = [
  //基础数据配置
  {
    name: 'base-config',
    path: 'base-config',
    component: () => import('@/page/main/baseConfig/channel-relative'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '配置渠道映射关系', path: '/main/base-config' },
      ],
    },
  },
  {
    name: 'dictionary-config',
    path: 'dictionary-config',
    component: () => import('@/page/main/baseConfig/dictionaryConfig/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '字典关系表配置', path: '/main/dictionary-config' },
      ],
    },
  },
  {
    name: 'add-dictionary',
    path: 'add-dictionary',
    component: () => import('@/page/main/baseConfig/dictionaryConfig/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '字典关系表配置', path: '/main/dictionary-config' },
        { title: '添加字典关系', path: '/main/add-dictionary' },
      ],
    },
  },
  {
    name: 'dictionary-relative',
    path: 'dictionary-relative',
    component: () => import('@/page/main/baseConfig/dictionary-relative'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '品牌品类关系配置', path: '/main/dictionary-relative' },
      ],
    },
  },
  {
    name: 'system-management',
    path: 'system-management',
    component: () => import('@/page/main/baseConfig/systemManagement'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '配置系统管理权限', path: '/main/system-management' },
      ],
    },
  },
  {
    name: 'system-management-user',
    path: 'system-management/:id/user',
    component: () => import('@/page/main/baseConfig/systemManagement/user'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '配置系统管理权限', path: '/main/system-management' },
        { title: '配置系统人员', path: '' },
      ],
    },
  },
  {
    name: 'country-code',
    path: 'country-code',
    component: () => import('@/page/main/baseConfig/country-code/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '国家编码配置', path: '/main/country-code' },
      ],
    },
  },
  {
    name: 'system-management-territory',
    path: 'system-management-territory',
    component: () => import('@/page/main/baseConfig/systemManagement/territory'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '代理区域配置', path: '/main/system-management-territory' },
      ],
    },
  },
  {
    name: 'system-management-dictionary',
    path: 'system-management-dictionary',
    component: () => import('@/page/main/baseConfig/systemManagement/dictionary'),
    meta: {
      router: [
        {
          title: '首页',
          path: '/main/home',
        },
        {
          title: '字典业务数据配置',
          path: '/main/system-management-dictionary',
        },
      ],
    },
  },
  {
    name: 'system-management-territory',
    path: 'system-management-territory',
    component: () => import('@/page/main/baseConfig/systemManagement/territory'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '代理区域配置', path: '/main/system-management-territory' },
      ],
    },
  },
  {
    name: 'system-management-territory',
    path: 'system-management-territory',
    component: () => import('@/page/main/baseConfig/systemManagement/territory'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '代理区域配置', path: '/main/system-management-territory' },
      ],
    },
  },
]
